import React from 'react';
import {compose} from 'redux';
import {translate} from 'react-i18next';
import {Form, Input} from 'antd';
import _ from "lodash";
import MultilanguageInput from "../../../components/multilanguage-input";
import {isIDValidWithHelp} from "../../../utils/artefactValidators";

const mapPropsToFields = ({value}) => ({
  Id: Form.createFormField({value: value !== null ? value.Id : null}),
  Name: Form.createFormField({value: value !== null ? value.Name : null}),
});

const onFieldsChange = (props, fields) => props.onChange(_.mapValues(fields, ({value}) => value));

const AgencyForm = ({
                      t,
                      value,
                      form
                    }) =>
  <Form layout={"inline"}>
    <Form.Item
      label={t("scenes.configuration.appConfig.agencyForm.id")}
      className="form-item-required"
      style={{marginBottom: 0}}
      validateStatus={value && isIDValidWithHelp(t, value.Id).help ? "warning" : null}
      help={value && isIDValidWithHelp(t, value.Id).help}
    >
      {form.getFieldDecorator("Id", {
        getValueFromEvent: e => e.target.value.toUpperCase()
      })(
        <Input
          title={form.getFieldValue("Id")}
          style={{textTransform: "uppercase"}}
        />
      )}
    </Form.Item>
    <Form.Item
      label={t("scenes.configuration.appConfig.agencyForm.name")}
      className="form-item-required"
      style={{marginBottom: 0}}
    >
      {form.getFieldDecorator("Name")(
        <MultilanguageInput title={form.getFieldValue("Name")}/>
      )}
    </Form.Item>
  </Form>;

export default compose(
  translate(),
  Form.create({mapPropsToFields, onFieldsChange})
)(AgencyForm);
